var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"first-number":"","last-number":""},on:{"change":_vm.onPageChange},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }